module.exports = __webpack_public_path__ + "img/fruit-pears-350x184.e2955f6b.jpg";